import { Check } from 'lucide-react';
import { UserAvatarWithName } from '../../ui/user-avatar-with-name.jsx';
import { cn } from '../../../lib/utils.js';
export { formatUserOptions } from './format-user-options';
export var AvatarValueDisplay = function (option) {
    if (!option.user) {
        return <span>{option.label}</span>;
    }
    return (<span className="flex items-center gap-2">
      <UserAvatarWithName firstName={option.user.firstName} lastName={option.user.lastName} avatarUrl={option.user.avatarUrl} avatarClassName="h-6 w-6" size="sm"/>
      {option.statusLabel && (<span className="text-muted-foreground text-xs">{option.statusLabel}</span>)}
    </span>);
};
export var AvatarWithEmailValueDisplay = function (option) {
    if (!option.user) {
        return <span>{option.label}</span>;
    }
    return (<span className="flex items-center gap-2">
      <UserAvatarWithName firstName={option.user.firstName} lastName={option.user.lastName} email={option.user.email} avatarUrl={option.user.avatarUrl} avatarClassName="h-6 w-6" showEmail size="sm"/>
      {option.statusLabel && (<span className="text-muted-foreground text-xs">{option.statusLabel}</span>)}
    </span>);
};
export var AvatarMenuOption = function (_a) {
    var isDisabled = _a.isDisabled, isSelected = _a.isSelected, data = _a.data, innerProps = _a.innerProps;
    return (<div className={cn('flex cursor-pointer items-center justify-between gap-2 px-2 py-1.5', isSelected
            ? 'bg-accent text-accent-foreground'
            : 'hover:bg-accent hover:text-accent-foreground', isDisabled && 'cursor-not-allowed opacity-50 hover:bg-transparent')} {...innerProps}>
      {AvatarValueDisplay(data)}
      {isSelected && <Check className="h-4 w-4 opacity-50"/>}
    </div>);
};
export var AvatarWithEmailMenuOption = function (_a) {
    var isDisabled = _a.isDisabled, isSelected = _a.isSelected, data = _a.data, innerProps = _a.innerProps;
    return (<div className={cn('flex cursor-pointer items-center justify-between gap-2 px-2 py-1.5', isSelected
            ? 'bg-accent text-accent-foreground'
            : 'hover:bg-accent hover:text-accent-foreground', isDisabled && 'cursor-not-allowed opacity-50 hover:bg-transparent')} {...innerProps}>
      {AvatarWithEmailValueDisplay(data)}
      {isSelected && <Check className="h-4 w-4 opacity-50"/>}
    </div>);
};
